import Container from "./Container";
import Navbar from "./Navbar";
import cx from "classix";

type Props = {
  title?: React.ReactNode;
  className?: string;
  homePage?: boolean;
};

export default function Header({ title, className, homePage = false }: Props) {
  return (
    <div className="bg-black-header">
      <Container
        tag="header"
        className={cx(
          "flex flex-col bg-[90%_bottom] bg-no-repeat px-20 text-white",
          className,
          homePage
            ? "h-[650px] bg-[length:auto_650px] md:h-[750px] md:bg-[length:auto_750px]"
            : "h-[648px] bg-[length:auto_500px] md:bg-[length:auto_580px]"
        )}
      >
        <Navbar />
        {title && (
          <div
            className={cx(
              "mt-auto flex items-end",
              homePage ? "pb-12 md:pb-20" : "pb-16"
            )}
          >
            <h1 className="text-r-6xl w-3/5 font-normal leading-none md:w-2/5">
              {title}
            </h1>
          </div>
        )}
      </Container>
    </div>
  );
}
